import React from "react";

import { CountryImg } from "./style";
import usaFlag from "src/assets/usaFlag.svg";
import uaeFlag from "src/assets/uaeFlag.svg";
import eurFlag from "src/assets/eurFlag.svg";

interface AccountDetail {
  id: string;
  name: string;
  Icon: React.ReactNode;
  values: {
    label: string;
    value: string;
    tooltip?: string;
  }[];
  disable?: boolean;
}

export const accounts: AccountDetail[] = [
  {
    id: "usa",
    name: "USD",
    Icon: <CountryImg src={usaFlag} />,
    values: [
      {
        label: "Account Name",
        value: "FinaMaze Limited - Clients Account",
        tooltip:
          "Your Money & Assets are held separate from our Corporate accounts.",
      },
      {
        label: "Beneficiary Address",
        value: "ADGM, 111- 14th floor - Al Khatem Tower - Abu Dhabi - UAE",
        tooltip: "",
      },
      {
        label: "Bank Name",
        value: "Abu Dhabi Islamic Bank (ADIB)",
        tooltip: "",
      },
      {
        label: "Bank Address",
        value:
          "Abu Dhabi Islamic Bank Head Office - Sheikh Rashid Bin Saeed Street - P.O.Box 313, Abu Dhabi, UAE",
        tooltip: "",
      },
      {
        label: "Swift Code",
        value: "ABDIAEADXXX",
        tooltip: "",
      },
      {
        label: "Comment/Note/Reference (for a swift reconciliation)",
        value: "First and Last name",
        tooltip: "",
      },
      {
        label: "IBAN",
        value: "AE940500000000019223294",
        tooltip: "",
      },
      {
        label: "Account Number",
        value: "19223294",
        tooltip: "",
      },
    ],
  },
  // comment this out if you want to hide this account
  {
    id: "uae",
    name: "AED",
    Icon: <CountryImg src={uaeFlag} />,
    values: [
      {
        label: "Account Name",
        value: "FinaMaze Limited - Clients Account",
        tooltip:
          "Your Money & Assets are held separate from our Corporate accounts.",
      },
      {
        label: "Beneficiary Address",
        value: "ADGM, 111- 14th floor - Al Khatem Tower - Abu Dhabi - UAE",
        tooltip: "",
      },
      {
        label: "Bank Name",
        value: "Abu Dhabi Islamic Bank (ADIB)",
        tooltip: "",
      },
      {
        label: "Bank Address",
        value:
          "Abu Dhabi Islamic Bank Head Office - Sheikh Rashid Bin Saeed Street - P.O.Box 313, Abu Dhabi, UAE",
        tooltip: "",
      },
      {
        label: "Swift Code",
        value: "ABDIAEADXXX",
        tooltip: "",
      },
      {
        label: "Comment/Note/Reference (for a swift reconciliation)",
        value: "First and Last name",
        tooltip: "",
      },
      {
        label: "IBAN",
        value: "AE950500000000019223179",
        tooltip: "",
      },
      {
        label: "Account Number",
        value: "19223179",
        tooltip: "",
      },
    ],
    disable: false,
  },
  {
    id: "eur",
    name: "EUR",
    Icon: <CountryImg src={eurFlag} />,
    values: [
      {
        label: "Account Name",
        value: "FinaMaze Limited - Clients Account",
        tooltip:
          "Your Money & Assets are held separate from our Corporate accounts.",
      },
      {
        label: "Beneficiary Address",
        value: "ADGM, 111- 14th floor - Al Khatem Tower - Abu Dhabi - UAE",
        tooltip: "",
      },
      {
        label: "Bank Name",
        value: "Abu Dhabi Islamic Bank (ADIB)",
        tooltip: "",
      },
      {
        label: "Bank Address",
        value:
          "Abu Dhabi Islamic Bank Head Office - Sheikh Rashid Bin Saeed Street - P.O.Box 313, Abu Dhabi, UAE",
        tooltip: "",
      },
      {
        label: "Swift Code",
        value: "ABDIAEADXXX",
        tooltip: "",
      },
      {
        label: "Comment/Note/Reference (for a swift reconciliation)",
        value: "First and Last name",
        tooltip: "",
      },
      {
        label: "IBAN",
        value: "AE400500000000019223296",
        tooltip: "",
      },
      {
        label: "Account Number",
        value: "19223296",
        tooltip: "",
      },
    ],
    disable: false,
  },
];
